import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { OrganizationDocumentDetailsViewTopBar } from "./TopBar"

export const organizationDocumentDetailsViewLayoutHandle: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: OrganizationDocumentDetailsViewTopBar,
}
